if (!customElements.get("clg-form")) {
  class CLGForm extends HTMLElement {
    constructor() {
      super();
      this.resultTitleElem = window.document.querySelector("#clg-result-title");
      this.resultSubtitleElem = window.document.querySelector("#clg-result-subtitle");
    }

    showInfo(clgData) {}

    resetResult() {
      this.resultTitleElem.innerText = "";
      this.resultSubtitleElem.innerText = "";
    }

    showResult(success, error_code) {
      if (success) {
        switch (error_code) {
          case "code_verified": {
            this.resultTitleElem.innerText = "Congratulations!";
            this.resultSubtitleElem.innerText = "Your CLG Code is verified.";
          }
          case "info_not_matched": {
            this.resultTitleElem.innerText = "Sorry!";
            this.resultSubtitleElem.innerText = "Your code is verified by someone else";
          }
          default: {
            this.resultTitleElem.innerText = "Sorry!";
            this.resultSubtitleElem.innerText = "Your code can't be verified.";
          }
        }
      } else {
        this.resultTitleElem.innerText = "Error!";
        this.resultSubtitleElem.innerText = "Server Error. Please Try Again Later";
      }
    }

    submitClg(code, phone_code, phone_number) {
      this.resetResult();
      const _that = this;
      const url = "/tools/clg/validate_code";
      const postBody = JSON.stringify({ code, phone_code, phone_number });
      fetch(url, {
        body: postBody,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            _that.showResult(true, res.data.error_code);
          } else {
            _that.showResult(false, "");
          }
        })
        .catch((err) => {
          _that.showResult(false, "");
        });
    }

    toggleErrorMessage(input, field) {
      const errorMessageSpan = field.querySelector(".js-error-message");

      if (!errorMessageSpan) return;

      errorMessageSpan.parentElement.classList.toggle(
        "hidden",
        input.validity.valid
      );
      errorMessageSpan.parentElement.classList.toggle(
        "has-error",
        !input.validity.valid
      );

      errorMessageSpan.innerHTML =
        input.type == "email"
          ? window.validationStrings.invalidEmail
          : input.validationMessage;
    }

    setFieldValidity(input) {
      input.setAttribute("aria-invalid", !input.validity.valid);
      const field = input.closest(".js-field-wrapper");
      if (!field) return;
      field.classList.toggle("has-error", !input.validity.valid);
      this.toggleErrorMessage(input, field);
    }

    handleSubmit(event) {
      event.preventDefault();
      console.log(event);
      const isValid = this.form.reportValidity();
      const formData = new FormData(this.form);
      var jsonData = {};
      formData.forEach(function(value, key){
          jsonData[key] = value;
      });
      this.submitClg(jsonData['code'], jsonData['phone_code'], jsonData['phone_number']);
    }

    setEventHandlers() {
      for (const input of this.form.elements) {
        if (input.hasAttribute("data-no-validate")) continue;

        input.addEventListener("invalid", (event) => {
          event.preventDefault();
          this.setFieldValidity(input);
        });

        ["input", "blur", "change"].forEach((eventName) => {
          input.addEventListener(eventName, () => {
            this.setFieldValidity(input);
          });
        });
      }
    }

    connectedCallback() {
      this.form = this.querySelector("form");
      console.log(this.form)
      if (!this.form) return;

      this.form.addEventListener("submit", this.handleSubmit.bind(this));
    
      this.setEventHandlers();
    }
  }

  customElements.define("clg-form", CLGForm);
}
